export default __webpack_public_path__ + "static/media/Standing.ca25502a.svg";